import {formatDisplayPrice} from "../../../../../res/dataServices/pricing";
import CartSummaryLine from "./CartSummaryLine";
import useCheckoutStore from "../../../../cart/store/checkoutStore";
import {useShallow} from "zustand/react/shallow";

const CartSummary = () => {

    const {
        guidePrice,
        grandTotal,
        charges,
        previousPayment,
        overPayment,
        totalDue
    } = useCheckoutStore(
        useShallow((state) => ({
            guidePrice: state.order?.TotalLines,
            grandTotal: state.order?.GrandTotal,
            charges: state.charges?.lines,
            previousPayment: state.paymentDetails?.previousPayment,
            overPayment: state.getOverpayment(),
            totalDue: state.getTotalDue()
        }))
    );

    return (
        <div className="cart-section">
            {(charges ?? []).map((e,i) =>
                <CartSummaryLine
                    key={i}
                    type={e.C_Charge_ID.Name}
                    price={formatDisplayPrice(e.LineNetAmt)}
                />
            )}
            <CartSummaryLine type="Guide Price" price={formatDisplayPrice(guidePrice)} />
            {Boolean(totalDue !== grandTotal) &&
                <CartSummaryLine type="Sub-Total" price={formatDisplayPrice(grandTotal)} />
            }
            {Boolean(previousPayment) &&
                <CartSummaryLine type="Previous payment" price={"-"+formatDisplayPrice(previousPayment)} />
            }
            {Boolean(overPayment) &&
                <CartSummaryLine type="Over payment" price={formatDisplayPrice(overPayment)} />
            }
            <CartSummaryLine type="Total" price={formatDisplayPrice(totalDue)} bold />
        </div>
    )
}

export default CartSummary;
